/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Account_General_SuccessInputs */



/**
* | output |
* | --- |
* | "User information has been updated correctly" |
*
* @param {My_Account_General_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const my_account_general_success = /** @type {((inputs?: My_Account_General_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Account_General_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("User information has been updated correctly")
	return /** @type {LocalizedString} */ ("Les informations utilisateurs ont correctement été mises à jour")
});